import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const OnboardingContainer = styled.div`
  display: flex;

  width: 100%;
  height: 100dvh;

  background-color: ${({ theme }) => theme.palette.background.default};
`;

export const RightPanelWrapper = styled.div`
  display: none;
  width: 50%;
  position: relative;
  background: linear-gradient(90deg, #fae4ce 0%, #ecdbfe 100%);
  overflow: hidden;

  ${({ theme }) => theme.breakpoints.up(theme.breakpoints.values.md)} {
    display: block;
  }
`;

export const Illustration = styled.img`
  position: absolute;
  left: 20%;
  top: 50%;

  height: 80%;

  transform: translateY(-50%);
`;

export const LeftPanel = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 50%;
  }
`;

export const LeftPanelContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};

  min-height: 0;
  width: 100%;
  max-width: ${({ theme }) => `calc(34.4rem + ${theme.spacing(8)})`};
  padding: ${({ theme }) => `${theme.spacing(1.5)} ${theme.spacing(4)} 0`};
  margin: 0 auto;
`;

export const Body = styled.form`
  overflow-y: auto;
  padding: ${({ theme }) => `${theme.spacing(1.5)}`};

  padding: ${({ theme }) => `${theme.spacing(6)}`};
  margin: ${({ theme }) => `-${theme.spacing(6)}`};

  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Subtitle = styled.p`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  padding: ${({ theme }) => `${theme.spacing(1)} 0 ${theme.spacing(4)}`};
  margin: 0;

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const FooterArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};

  padding: ${({ theme }) => `0 0 ${theme.spacing(2)}`};

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};

  padding: 0;
  margin: 0;

  list-style: none;
`;

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(3)};

  padding: ${({ theme }) => `${theme.spacing(3)} ${theme.spacing(4)}`};

  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.spacing(2)};
`;

export const ListItemIconContainer = styled.span`
  display: block;

  padding: ${({ theme }) => theme.spacing(1.5)};

  border-radius: ${({ theme }) => theme.spacing(1)};
  background: ${({ theme }) =>
    theme.palette.primaryExtended.opacityBackgroundBackground};

  font-size: 2rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.primaryExtended.opacityBackgroundText};
`;

export const ListItemContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const ListItemTitle = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.subtitle2)};
  color: ${({ theme }) => theme.palette.text.primary};
`;
